import i18next from '../i18n';

export const MIN_PASSWORD_LENGTH = 8;
export const passwordValidationRule = { required: i18next.t('Enter your password'), minLength: MIN_PASSWORD_LENGTH };
